/*
  TimelessXI: keeps a size button's hidden companion checkboxes (other women's/youth conversions of the same size, see
  snippets/txi-size-facet.liquid) ticked together with the visible one. Runs in the capture phase, before Dawn's
  facets.js reads the form, and is delegated from the document because filters are re-rendered after every change.
*/
(() => {
  if (window.txiSizeFacet) return;
  window.txiSizeFacet = true;
  const sync = (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('[data-txi-size-group]')) return;
    const chip = input.closest('.txi-size-facet__chip');
    chip.querySelectorAll('[data-txi-size-companion]').forEach((companion) => {
      companion.checked = input.checked;
    });
    chip.classList.toggle('is-active', input.checked);
  };
  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);
})();
